import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import SortableTable from "../../components/SortableTable";
import SummaryChart from "../lenders/SummaryChart";
import MoneyTotal from "../../components/fields/MoneyTotal";
import LenderTitle from "../../components/fields/LenderTitle";
import Order from "../../components/fields/Order";
import Product from "../../components/fields/Product";
import CSVDownload from "../../components/CsvDownload";

const OrderSummaryByDate = ({ data, dataDate, filtration }) => {
  if (data === null) {
    return (
        <CardBody className="text-center">
          <h5>Click &quot;Show results&quot; to load data</h5>
        </CardBody>
    );
  }

  if (!data || data.length === 0) {
    return (
        <CardBody className="text-center">
          <h5>Data not found</h5>
        </CardBody>
    );
  }

  const columns = [
    {
      id: 'date',
      name: "Date",
      selector: row => row.date,
      cell: (row) => <span>{row.date}</span>,
      sortable: true,
    },
    {
      name: "Lender",
      selector: (row) => row.order.lender.title.toLowerCase(),
      cell: (row) => (
          <LenderTitle title={row.order.lender.title} id={row.order.lender.id} />
      ),
      sortable: true,
    },
    {
      name: "Order",
      selector: (row) => row.order.id,
      cell: (row) => <Order order={row.order} />,
      sortable: true,
    },
    {
      name: "Product",
      selector: (row) => row.order.product.id,
      cell: (row) => <Product product={row.order.product} />,
      sortable: true,
    },
    {
      name: "Sent",
      selector: (row) => row.leads,
      cell: (row) => <span className="font-weight-bold">{row.leads}</span>,
      sortable: true,
    },
    {
      name: "Matched",
      selector: (row) => row.matched,
      cell: (row) => (
          <span className={`font-weight-bold ${row.matched ? "text-success" : ""}`}>
          {row.matched}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Unmatched",
      selector: (row) => row.unmatched,
      sortable: true,
    },
    {
      name: "Returned",
      selector: (row) => row.returned,
      cell: (row) => (
          <span className={`${row.returned ? "text-primary" : ""}`}>
          {row.returned}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Error",
      selector: (row) => row.error,
      cell: (row) => (
          <span className={`${row.error ? "text-warning" : ""}`}>
          {row.error}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Timeout",
      selector: (row) => row.timeout,
      cell: (row) => (
          <span className={`${row.timeout ? "text-danger" : ""}`}>
          {row.timeout}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Total",
      selector: (row) => row.total,
      cell: (row) => (row.total ? <MoneyTotal money={row.total} /> : "$0"),
      sortable: true,
    },
  ];

  let totalLeads = 0,
      totalMatched = 0,
      totalUnmatched = 0,
      totalError = 0,
      totalReturned = 0,
      totalTimeout = 0,
      totalTotal = 0;

  data.forEach((item) => {
    totalLeads += item.leads;
    totalMatched += item.matched;
    totalUnmatched += item.unmatched;
    totalError += item.error;
    totalReturned += item.returned;
    totalTimeout += item.timeout;
    totalTotal += item.total;
  });

  return (
      <>
        <div className="row mb-4 mt-1">
          <Col md={12}>
            <div className="d-flex justify-content-end align-items-center">
              <span className='font-weight-bold'>Summary</span>&nbsp;<span>Report - </span>
              <CSVDownload
                  url="/admin/lender/summaryorderexport"
                  filename="OrdersSummary"
                  filtration={filtration}
              />
            </div>
          </Col>
        </div>
        {dataDate && dataDate.length > 2 && (
            <div>
              <SummaryChart inputData={dataDate}/>
            </div>
        )}
        <SortableTable columns={columns} data={data} pagination={false} defaultSortFieldId="date" defaultSortAsc={false}/>
        <Card className="flex-fill w-100 p-3">
          <h4>Summary:</h4>
          <ul className="bull list-unstyled mb-0">
            <li>
              Sent: <span className="font-weight-bold">{totalLeads}</span>
            </li>
            <li>
              Matched:{" "}
              <span className={`font-weight-bold ${totalMatched ? "text-success" : ""}`}>
              {totalMatched}
            </span>
            </li>
            <li>
              Unmatched: <span className="font-weight-bold">{totalUnmatched}</span>
            </li>
            <li>
              Returned:{" "}
              <span className={`font-weight-bold ${totalReturned ? "text-primary" : ""}`}>
              {totalReturned}
            </span>
            </li>
            <li>
              Error:{" "}
              <span className={`font-weight-bold ${totalError ? "text-warning" : ""}`}>
              {totalError}
            </span>
            </li>
            <li>
              Timeout:{" "}
              <span className={`font-weight-bold ${totalTimeout ? "text-danger" : ""}`}>
              {totalTimeout}
            </span>
            </li>
            <li>
              Total:{" "}
              <span className="font-weight-bold">
              {totalTotal ? <MoneyTotal money={totalTotal}/> : "$0"}
            </span>
            </li>
          </ul>
        </Card>
      </>
  );
};

export default OrderSummaryByDate;
